module.exports = __webpack_public_path__ + "img/union_pay.e4918efc.svg";